module.exports = __webpack_public_path__ + "img/water-meter.c5f6058c.png";